"use client";

import { useEffect, useState } from 'react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

interface EmojiPickerProps {
  onEmojiSelect: (emoji: string) => void;
  theme?: 'light' | 'dark';
}

export default function EmojiPicker({ onEmojiSelect, theme }: EmojiPickerProps) {
  const [currentTheme, setCurrentTheme] = useState<'light' | 'dark'>(theme || 'light');

  useEffect(() => {
    // Check if user prefers dark mode
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    // If no theme prop provided, use system preference
    if (!theme) {
      setCurrentTheme(prefersDark ? 'dark' : 'light');
    }

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      if (!theme) {
        setCurrentTheme(e.matches ? 'dark' : 'light');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme]);

  return (
    <Picker
      data={data}
      onEmojiSelect={(emoji: any) => onEmojiSelect(emoji.native)}
      theme={currentTheme}
      previewPosition="none"
      skinTonePosition="none"
      searchPosition="top"
      navPosition="bottom"
      perLine={8}
      maxFrequentRows={1}
    />
  );
}